import type { AutoFixProvider } from '@/lib/ai-review-settings/schema';

export type FixAllProviderCopy = {
  footerLinkLabel: string;
  buildProminentTip: (fixAllUrl: string) => string;
};

const FIX_ALL_PROVIDER_COPY: Record<AutoFixProvider, FixAllProviderCopy> = {
  cubic: {
    footerLinkLabel: 'Fix all with cubic',
    buildProminentTip: (fixAllUrl) =>
      `**Tip**: instead of fixing issues one by one [fix them all with cubic](${fixAllUrl})`,
  },
  cursor_cloud_agent: {
    footerLinkLabel: 'Fix all with Cursor',
    buildProminentTip: (fixAllUrl) =>
      `**Tip**: instead of fixing issues one by one [fix them all with Cursor](${fixAllUrl})`,
  },
};

export function resolveFixAllProviderCopy(provider: AutoFixProvider): FixAllProviderCopy {
  return FIX_ALL_PROVIDER_COPY[provider];
}
